import React, { useCallback, useMemo, useReducer } from 'react';

import bookmarksConstants    from './bookmarks.constants';
import BookmarksContext      from './bookmarks.context';
import bookmarksReducer      from './bookmarks.reducer';
import bookmarksInitialState from './bookmarks.state';

/**
 * @type {React.FC}
 */

const BookmarksProvider = function({
  children,
  value = bookmarksInitialState,
}) {
  const [state, dispatch] = useReducer(bookmarksReducer, value);

  const hideModal = useCallback(() => {
    dispatch({ type: bookmarksConstants.HIDE_MODAL });
  }, [dispatch]);
  const showModal = useCallback(() => {
    dispatch({
      type: bookmarksConstants.SHOW_MODAL,
    });
  }, [dispatch]);

  const context = useMemo(
    () => ({
      ...state,
      hideModal,
      showModal,
    }),
    [hideModal, showModal, state],
  );

  return (
    <BookmarksContext.Provider value={context}>
      {children}
    </BookmarksContext.Provider>
  );
};

export default BookmarksProvider;
